/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-over-layout :custom-class="(customClass)" :layout="(['header', 'footer'])" :useDefaultNavbar="(false)" :needScroll="(true)" blankPageType="blank-page" :useBlankPage="(useBlankPage)" :blankImageUrl="(blankImageUrl)" :blankContextTitle="(blankContextTitle)" :blankContextSubTitle="(blankContextSubTitle)" :hasBlankButton="(hasButton)" @blank-retry="loadOrderBaseInfo" :navbarClickLeft="(goBackReport)" @onscroll="handleScroll"><div slot="header"><es-navbar :style="[(navbarStyle)] | transRpxStyle" :left-arrow="(true)" @click-left="goBackReport" :custom-class="(scrambleNavBar)" :customFillboxClass="(scrambleFillBox)"><template v-if="(!fromChangeTicket)"><div class="es-navbar-title" v-if="(isFromScramble || !userGroup)">{{ titleBar }}</div><div class="es-navbar-title" v-else><date-card ref="__mpx_ref_date_card__" :value="(time)" :date-type="('MM-dd')" checkType="single" :linking="(linking)" :isUpdateEveryTime="(true)" :checkRange="(7)" dateType="M月d日" :maxDate="(maxDateTime)" :minDate="(minDateTime)" :maxHeaderDate="(headerMaxDateTime)" :minHeaderDate="(headerMinDateTime)" startText="去程" endText="返程" title="选择前往日期" :closeable="(true)" :disable="(dateCardDisabled)" @confirm="onConfirm" @handleClickDay="handleClickDay" @reportClick="dateCardClickReport"/></div></template><change-navbar :process="(2)" :title="(titleBar)" v-else/><div slot="right" v-if="(isFromScramble || userGroup)"><mpx-view @tap="sideTitle.jumpFn" class="es-navbar-right">{{ sideTitle.text }}</mpx-view></div></es-navbar></div><template slot="bg-icon" v-if="(isFromScramble && !loadInitDataFail)"><mpx-image mode="widthFix" src="https://img-hxy021.didistatic.com/static/starimg/img/8rhBDFRo381693374074807.png" class="scrambling-bg"/></template><mpx-view @scroll="handleScroll" :class="(!isFromScramble && 'notscramble')" class="card-main" v-if="(showTrainInfomation)"><probability :probability="(scrableSuccessRate)" v-if="(isFromScramble)"/><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/CJc2VEHDB81692188876513.png" class="scramble-text-pic" v-if="(isFromScramble)"/><template v-if="(isFromScramble)"><scramble-select-card :trainCodeList="(trainCodeList)" :startDateList="(startDateList)" :selectDateCurList="(selectDateCurList)" :selectDateList="(selectDateList)" :trainSeatList="(trainSeatList)" :selectSeatCodeList="(selectSeatCodeList)" :lastSelectedSeatIndex="(lastSelectedSeatIndex)" :deadLineHour="(selectDeadline)" @openDeadLine="openDeadLine" @setSelectDateCurList="setSelectDateCurList" @setSelectSeatCodeList="setSelectSeatCodeList"/></template><template v-else-if="(isTransfer)"><transfer-info-card ref="__mpx_ref_transferCard__" :isExemption="(!!isExemption)" :trainInfo="(trainInfo)" :hasRightsChoosed="(hasRightsChoosed)" @showSSI="showSSI"/></template><template v-else-if="(isRecommendTicket)"><recommend-ticket-card :style="[({'margin': '0 -12px' })] | transRpxStyle" makeOrder/></template><template v-else><div class="new-train-card"><train-information-new :style="[({'z-index': '1','position': 'relative'})] | transRpxStyle" :noDetail="(!!userGroup)" @click="showSSI" :trainInfo="(trainInfo)"/><div class="selected-seat-info" v-if="(userGroup && hasRightsChoosed)">{{ hasSelectedSeatPrice }}</div><div :style='["height:12px"] | transRpxStyle' v-if="(userGroup)"></div><template v-if="(!userGroup)"><div class="seat-info"><div class="seat-info-left"><div class="seat-info-left-type">{{ ticketType }}</div><div class="seat-info-left-price">{{ ticketPrice }}</div><div class="service-writting" v-if="(offlineHandingFee)">便捷购票¥{{ offlineHandingFee }}</div></div><mpx-view @tap="sideTitle.jumpFn" class="seat-info-right"><mpx-image src="https://ut-static.udache.com/webx/sfc/j9QJ2xhfiMsq3IjQ5Bdf9.png" class="seat-info-right-image"/><span>{{ sideTitle.text }}</span></mpx-view></div></template></div></template><coupon-banner-simplify from="makeOrder" v-if="(!hasRightsChoosed && !isFromScramble && !isRecommendTicket)"/><div class="divider"/><template v-if="(userGroup && !this.isFromScramble && !isRecommendTicket)"><seat-information-group :isStudent="(isStudent)" :hasRightsChoosed="(hasRightsChoosed)" v-if="(!fromChangeTicket)"/><seat-information-new :style='["margin-bottom: 10px;"] | transRpxStyle' :isStudent="(isStudent)" :fromChangeTicket="(fromChangeTicket)" :isPreScramble="(isPreScramble)" @reportClick="seatInfoClickReport" v-else/></template><template><seat-rights-select-group ref="__mpx_ref_rightsSelectGroup__" :style="[({'margin-top': hasRightsChoosed ? '0' : '10px'})] | transRpxStyle" :hasRightsChoosed="(hasRightsChoosed)" @reportClick="seatInfoClickReport" @selectSeatRights="selectSeatRights" @openRightsDescDrawer="openServiceDescDrawer" v-if="(!fromChangeTicket && !isFromScramble && !isRecommendTicket)"/></template><template v-if="(userGroup && !this.isFromScramble && !this.isTransfer && !isRecommendTicket && !fromChangeTicket)"><seat-information-recommend :style='["margin-bottom: 10px;"] | transRpxStyle' :isStudent="(isStudent)" :hasRightsChoosed="(hasRightsChoosed)" :fromChangeTicket="(fromChangeTicket)" :isPreScramble="(isPreScramble)" @reportClick="seatInfoClickReport"/></template><template><div :style="[(mainStyle)] | transRpxStyle" class="no-account" v-if="(!fromChangeTicket && !isFromScramble && !is12306Login && !valueAddedServices)"><div class="no-account-left"><mpx-image src="https://ut-static.udache.com/webx/sfc/TGk18Kq3oyt6CtSD34ugT.png" class="no-account-left-icon"/><div class="no-account-left-text">登录12306</div></div><mpx-view @tap="openLoginDrawer" tabindex="0" class="no-account-right"><div class="no-account-right-text">去登录</div><mpx-image src="https://ut-static.udache.com/webx/sfc/ABpMMfCY4hCXirn-kGe0A.png" class="no-account-right-icon"/></mpx-view></div></template><Slogan :class='"slogan"' sloganIcon="https://ut-static.udache.com/webx/sfc/blxxpny0xNRP_MD-onS94.png" v-if="(!fromChangeTicket && !isFromScramble && !isRecommendTicket && !hasRightsChoosed)"/><div :style="[(mainStyle)] | transRpxStyle"><template><template v-if="(fromChangeTicket)"><change-tip/><passenger-change-check-list :passengers="(passengersForChange)" @check="checkPassengersForChange"/></template><div class="passenger-card" v-else><passenger-make-order-card @list="setPassengerList" @select="setCurPassengerIndexList" :passengerSource="(passengerSource)" :showArrow="(false)" :passengerList="(currentPassengerList)"/><mpx-view @tap="addPassenger" class="passenger-card-add"><mpx-image :src="(passengerAddIcon)" class="passenger-card-add-icon"/><span :class="(isFromScramble && 'passenger-add-text-black')" class="link-btn-text passenger-card-add-text">{{ passengerAddText }}</span></mpx-view></div></template><template v-if="(!fromChangeTicket)"><div class="contact-phone"><div class="form-label contact-item">联系手机</div><div class="form-value"><mpx-input type="text" ref="telephone" placeholder="用于接受确认短信" placeholderStyle="color: #cccccc" @input="onPhoneChange($event)" :value="phoneNum" mpxModelEvent="input" @mpxModel='__model("phoneNum", $event, ["value"], undefined)' class="contact-item contact-phone-input"/><div :class="({'error-tip':true,active:phoneCheckDesc})">{{
                phoneCheckDesc
              }}</div></div></div></template><package-channel v-if="(isFromScramble)"/><dual-channel v-if="(isFromScramble)"/><template v-if="(isSupportChooseSeats)"><select-seat-card v-for="(item, index) in (selectSeatInfo)" :key="item.index" :seatIndex="(index)" :supportChoose="(notSleeperSeat(item,index))" @handle="onSeatClick" @silent="onSilentClick" :seatLength="(getSeatLength(item))" @click="showTips" :max="(fromChangeTicket ? checkedPassengersForChange.length : curPassengerIndexList.length)" :isMute="(makeOrderInfo.special_flag === 1 ? true:false)" :isTransfer="(isTransfer)" v-if="(!isFromScramble)"/></template><template v-if="(regularService)"><make-order-service-business @openRightsDescDrawer="openServiceDescDrawer"/></template><template v-if="(!regularService && showRightsDescBar && !fromChangeTicket)"><service-desc-bar @openRightsDescDrawer="openServiceDescDrawer"/></template><div class="protocol-container" v-if="(licenseCheckedDefault)"><mpx-view :class="({'text-color': licenseAgreementSelected})" @tap="licenseClick" class="protocol-text">{{
            reminders != null ? reminders.purchase_service : ''
          }}</mpx-view><mpx-view :class="({'url-color': licenseAgreementSelected})" @tap="jumpToH5(item, index)" v-for="(item, index) in (purchaseList)" class="protocol-url">《{{ item.name }}》</mpx-view></div><div class="scramble-icon-wrapper" v-if="(isFromScramble)"><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/jPvZLTRgZs1692788014403.png" class="scramble-icon"/></div></div></mpx-view><div :style="[(footStyle)] | transRpxStyle" slot="footer" :class="({'footer-fixed': isDetailShow})" class="footer" v-if="(!loadInitDataFail)"><div class="exemption-tips" v-if="(trainInfo.is_ticket_period && userGroup && !isFromScramble && !fromChangeTicket && !valueAddedServices)"><div class="exemption-tips-price">便携购票 +{{offlineHandingFee}}/人</div><div class="exemption-tips-text">该时段12306暂不支持购票，滴滴支持夜间正常出票</div></div><order-bottom-bar :canPay="(canPay)" :reminders="(reminders)" :purchaseList="(purchaseList)" :totalFeeInfo="(totalFeeInfo)" :licenseAgreementSelected="(licenseAgreementSelected)" :licenseCheckedDefault="(licenseCheckedDefault)" :isDetailShow="(isDetailShow)" :isFromScramble="(isFromScramble)" :changeTip="(fromChangeTicket ? '高价更改低价票，差额部分按照现行退票规则收取手续费，具体收费明细请查看改签预订须知。' : '')" @click="licenseClick" @submit="beforeSubmitOrder" @closeDetail="closeDetail" @changeDetail="changeDetail" :studentLength="(studentLength)" :isExemption="(isExemption)"/></div></es-over-layout><es-dialog id="es-dialog"/><es-dialog id="es-dialog-book"><div slot="content" class="bottom-conceal-text">我阅读并同意以下协议<mpx-view v-for="(item, index) in (purchaseList)" :key="item.index" @tap="jumpToLicense(item, index)" class="protocol url">《{{ item.name }}》</mpx-view></div></es-dialog><stay-info-drawer :show="(showStayInfo)" title="时刻表" :isTransfer="(isTransfer)" :stayInfo="(stayInfo)" :stayInfoList="(stayInfoList)" @close="closeSSI" @setStayInfo="setStayInfo"/><price-detail-info-alter :show="(isDetailShow)" :hasBottomBar="(true)" :priceDetailCardTip="(priceDetailCardTip)" :priceDetail="(priceDetail)" @close="closeDetail" :studentLength="(studentLength)" title="费用明细"/><deadline-drawer :show="(showDeadline)" :latestTrainStartTime="(latestTrainStartTime)" :selectDeadline="(selectDeadline)" @close="closeDeadline" @set="setSelectDeadline"/><login-drawer :login12306Amount="(login12306Amount)" :offlineAmount="(offlineAmount)" @close="closeLoginDrawer" @check="handleVerification(0)" @submit="handleVerification(1)"/><ticketing-notice-drawer :show="(showticketNotice)" :drawerPrice="(drawerPrice)" @check="handleVerification(1)" @close="closeTicketNotice" @getServiceDescription="getServiceDescription"/><ticketing-notice-drawer :noticeType="(1)" :show="(showtikcetPrompt)" :contactList="(errorPassengerList)" @close="closeTikcetPrompt" @addPassenger="addPassenger"/><login12306-drawer :show="(showLoginDrawer)" @close="closeLoginDrawer" @submit="handleVerification(1)" @openRightsDescDrawer="openRightsDescDrawer" @loginResetPassenger="loginResetPassenger" @checkPassenger="checkPassenger"/><nologin-description :show="(showServiceDescription)" @close="closeServiceDescription"/><rights-description-drawer :show="(showRightsDescDrawer)" :regularService="(regularService)" page="makeOrder" @close="closeRightsDescDrawer"/><worry-free-cancellation-drawer :show="(showWorryFreeDescDrawer)" :regularService="(regularService)" @close="closeWorryFreeDescDrawer" @chooseRight="chooseWorryFreeService"/><ticket-retention-drawer :show="(showNormalRetentionDrawer)" :currentPassengerList="(currentPassengerList)" @submit="beforeSubmitOrder(false)"/><scramble-retention-drawer :show="(showScrambleRetentionDrawer)" @submit="beforeSubmitOrder(false)"/><es-riskmanagement/><es-dialog id="es-dialog-conceal-login"><div slot="content"><div class="protocol text">我阅读并同意以下协议</div><mpx-view @tap="gotoAuthorizationAgreement" class="protocol url">《个人信息处理授权协议》</mpx-view><div class="protocol text">同意受本协议约束</div></div></es-dialog></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0f7f0447"}'>
  @import '~@/mixins/stylus/color.styl'

  .scrambling-bg
    width 100%
    position absolute
  .make-order-custom-class
    /deep/ .es-main
      background #F2F6F9
  /deep/ .scramble-navbar
    height 52px
  /deep/ .white-navbar
    background-color #fff
  /deep/ .white-fillbox
    position relative
    z-index 1
    background-color #fff
  .es-navbar-title
    font-size 18px
    font-weight 600
    color #000004
    font-weight PingFangSC
  .es-navbar-right
    font-size 12px
    color $train-color-333
    font-family PingFangSC-Regular
  .card-main
    display flex
    flex-direction column
    padding 0px 12px 130px 12px
    box-sizing border-box
    min-height 100%
    overflow-x hidden
    overflow-y auto
    position relative
    &.notscramble
      background-color #F2F6F9
    .scramble-text-pic
      width 193px
      height 28px
      margin-bottom 12px
  .new-train-card
    margin 0 -12px
    padding 0 10px 0
    background #fff
    padding-top 6px
    .selected-seat-info
      padding-left 14px
      margin-top 10px
      line-height 14px
      font-size 14px
      color #333
      font-family PingFangSC-Medium
      font-weight 500
  .account
    display flex
    flex-direction row
    background white
    align-items center
    &.out
      border-radius 8px
      height 48px
      padding 0px 12px
      justify-content space-between
    &.in
      justify-content space-between
  .account-name
    font-size 16px
    color black
    font-weight 500
    margin-left 8px
    text-overflow ellipsis
    overflow hidden
  .protocol
    font-size 12px
    display inline
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color $train-color-999
    &.url
      color $train-color-333
      text-overflow ellipsis
  .account-status
    font-size 14px
    color $train-color-999
  .contact-card
    border-radius 8px
    background white
    padding 5px 12px 10px
  .contact-tips
    color #999999
    font-size 12px
    margin-top 8px
  .contact-phone
    background-color #fff
    display flex
    border-radius 12px
    font-size 14px
    font-family PingFang SC
    padding 14px
    padding-bottom 2px
    margin-bottom 10px
    .form-label
      font-family PingFangSC-Semibold
      font-size 16px
      letter-spacing 0px
      color #333
      margin-right 16px
    .form-value
      flex 1
      .error-tip
        color red
        min-height 8px
        margin-top 3px
        font-size 12px
        &.active
          border-bottom 1px red solid
    .contact-item
      height 20px
      line-height 20px
      display flex
      align-items center
      min-height unset
      &.contact-phone-input
        height 20px
        line-height 20px
        font-size 16px
        color #666
        outline none
  .scramble-icon-wrapper
    width 100%
    display flex
    justify-content center
    margin-top 14px
    .scramble-icon
      height 41px
      width 224px
  .footer
    box-sizing border-box
    align-items center
    &-fixed
      z-index 10002
    background-color #ffffff
    box-sizing border-box
    .exemption-tips
      display flex
      flex-direction row
      justify-content space-between
      padding 13px 14px 17px 16px
      background linear-gradient(0deg, #FFF6F1, #FFF6F1), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
      .exemption-tips-price
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        color: #FF6400;
      .exemption-tips-text
        font-family: PingFang SC;
        font-size: 10px;
        font-weight: normal;
        line-height: 14px;
        text-align: right;
        letter-spacing: 0px;
        color: #666666;

  .divider
    height 10px
  .no-account
    display flex
    justify-content space-between
    padding 16px 14px
    align-items center
    background-color #fff
    border-radius 8px
    margin-bottom 8px
    .no-account-left
      display flex
      align-items center
      .no-account-left-icon
        height 18px
        width 16px
        margin-right 5px
      .no-account-left-text
        color #333
        font-family PingFangSC-Semibold
      font-size 16px
        line-height 16px
    .no-account-right
      display flex
      align-items center
      .no-account-right-text
        color #999
        margin-right 4.5px
        font-family PingFangSC-Regular
        font-size 14px
        line-height 14px
      .no-account-right-icon
        width 4.5px
        height 8px
  .seat-info
    display flex
    position relative
    justify-content space-between
    align-items flex-end
    padding 32px 14px 12px 14px
    background #C1DDFF
    color #333
    border-radius 10px
    transform translateY(-20px)
    &-left
      display flex
      line-height 14px
      font-size 14px
      &-type
        font-family PingFangSC-Medium
      &-price
        margin-left 5px
        font-family PingFangSC-Regular
      .service-writting
        margin-left 12px
        position relative
        &::before
          content ''
          height 10px
          width 0.5px
          position absolute
          top 50%
          left -6px
          background-color #999999
          transform translateY(-50%)
    &-right
      display flex
      font-family PingFangSC-Regular
      font-size 12px
      line-height 12px
      text-align right
      color #333
      align-items center
      &-image
        width 10px
        height 10px
        margin-right 2px
  .passenger-card
    background-color #fff
    margin-bottom 10px
    padding 0 12px
    border-radius 12px
    &-add
      display flex
      align-items center
      justify-content center
      width 100%
      border-radius 8px
      margin 0 auto
      font-size 15px
      line-height 48px
      text-align center
      color #FF6400
      &-icon
        height 15px
        width 15px
        margin-right 4px
      &-text
        font-family PingFangSC-Medium
      .passenger-add-text-black
        color #333
  input::-webkit-input-placeholder
    color #cccccc
    font-family PingFangSC
  .protocol-container
    margin-top 9px
    margin-left 4px
    div
      display inline
  .protocol-text
    font-size 11px
    font-family PingFangSC-Regular
    color #999999
  .protocol-url
    font-size 11px
    font-family PingFangSC-Regular
    color #FF6400
  .text-color
    color $train-color-999
  .url-color
    color $train-color-666
  .slogan
    position absolute
    bottom 60px
    left 50%
    transform translateX(-50%)
    margin 0
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0f7f0447"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0f7f0447%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isComponent&mpx&outputPath=components%2Findex0f7f0447%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0f7f0447"]
  export default processOption(
    currentOption,
    "page",
    "",
    "components/index0f7f0447/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'passenger-change-check-list':getComponent(require("./components/passenger-change-check-list.mpx?isComponent&outputPath=components%2Fpassenger-change-check-list0f51be6d%2Findex")),'change-tip':getComponent(require("./components/change-tip.mpx?isComponent&outputPath=components%2Fchange-tip6fac6a8c%2Findex")),'passenger-make-order-card':getComponent(require("./components/passenger-make-order-card.mpx?isComponent&outputPath=components%2Fpassenger-make-order-card49ae47db%2Findex")),'order-bottom-bar':getComponent(require("./components/order-bottom-bar.mpx?isComponent&outputPath=components%2Forder-bottom-bar5fbed49e%2Findex")),'scramble-select-card':getComponent(require("./components/scramble-select-card.mpx?isComponent&outputPath=components%2Fscramble-select-card279e998f%2Findex")),'deadline-drawer':getComponent(require("./components/deadline-drawer.mpx?isComponent&outputPath=components%2Fdeadline-drawer37c96134%2Findex")),'probability':getComponent(require("./components/probability.mpx?isComponent&outputPath=components%2Fprobability6db512d6%2Findex")),'login-drawer':getComponent(require("./components/login-drawer.mpx?isComponent&outputPath=components%2Flogin-drawer774f87ba%2Findex")),'ticketing-notice-drawer':getComponent(require("./components/ticketing-notice-drawer.mpx?isComponent&outputPath=components%2Fticketing-notice-drawer1166b12f%2Findex")),'transfer-info-card':getComponent(require("./components/transfer-info-card.mpx?isComponent&outputPath=components%2Ftransfer-info-card074f587b%2Findex")),'package-channel':getComponent(require("./components/package-channel.mpx?isComponent&outputPath=components%2Fpackage-channel5b5b5cdc%2Findex")),'rights-description-drawer':getComponent(require("./components/rights-description-drawer.mpx?isComponent&outputPath=components%2Frights-description-drawer4c54b8b8%2Findex")),'service-desc-bar':getComponent(require("./components/service-desc-bar.mpx?isComponent&outputPath=components%2Fservice-desc-barb0598286%2Findex")),'worry-free-cancellation-drawer':getComponent(require("./components/worry-free-cancellation-drawer.mpx?isComponent&outputPath=components%2Fworry-free-cancellation-drawer67c7d014%2Findex")),'ticket-retention-drawer':getComponent(require("./components/ticket-retention-drawer.mpx?isComponent&outputPath=components%2Fticket-retention-drawer610de601%2Findex")),'scramble-retention-drawer':getComponent(require("./components/scramble-retention-drawer.mpx?isComponent&outputPath=components%2Fscramble-retention-drawer1f2c86a0%2Findex")),'es-card-wrap1':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/card/card-wrap1.mpx?isComponent&outputPath=components%2Fcard-wrap120040920%2Findex")),'es-riskmanagement':getComponent(require("../login12306/components/rm/risk-management.mpx?isComponent&outputPath=components%2Frisk-management0659070a%2Findex")),'select-seat-card':getComponent(require("./components/order-select-seat-card/index.mpx?isComponent&outputPath=components%2Findex1f89acb7%2Findex")),'seat-rights-select-group':getComponent(require("./components/seat-rights-select-group/index.mpx?isComponent&outputPath=components%2Findex0ac0036d%2Findex")),'make-order-service-business':getComponent(require("./components/make-order-service-business/index.mpx?isComponent&outputPath=components%2Findex92ff474e%2Findex")),'stay-info-drawer':getComponent(require("../../components/stay-info-drawer.mpx?isComponent&outputPath=components%2Fstay-info-drawer20921e4e%2Findex")),'seat-information-recommend':getComponent(require("../../components/seat-information-new/seat-information-recommend.mpx?isComponent&outputPath=components%2Fseat-information-recommend21344ddc%2Findex")),'seat-information-group':getComponent(require("../../components/seat-information-new/seat-information-group.mpx?isComponent&outputPath=components%2Fseat-information-group0ff1ee9f%2Findex")),'recommend-ticket-card':getComponent(require("../../components/recommend-ticket/recommend-ticket-card.mpx?isComponent&outputPath=components%2Frecommend-ticket-card14bd2c2b%2Findex")),'drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'es-descriptions':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/descriptions/index.mpx?isComponent&outputPath=components%2Findexf02c563e%2Findex")),'date-card':getComponent(require("../train-detail/components/date-card/index.mpx?isComponent&outputPath=components%2Findex35be2d8b%2Findex")),'nologin-description':getComponent(require("../train-detail/components/nologin-description/index.mpx?isComponent&outputPath=components%2Findexf369d19a%2Findex")),'seat-information-new':getComponent(require("../../components/seat-information-new/index.mpx?isComponent&outputPath=components%2Findexc99a6152%2Findex")),'train-information-new':getComponent(require("../../components/train-information-new/index.mpx?isComponent&outputPath=components%2Findex7f4255a4%2Findex")),'change-navbar':getComponent(require("../../components/change-navbar/index.mpx?isComponent&outputPath=components%2Findex262f9081%2Findex")),'price-detail-info-alter':getComponent(require("../../components/price-detail-info-alter/index.mpx?isComponent&outputPath=components%2Findex853d8b3a%2Findex")),'order-common-card':getComponent(require("../../components/order-common-card/index.mpx?isComponent&outputPath=components%2Findexc3d6ce32%2Findex")),'dual-channel':getComponent(require("../../components/dual-channel/index.mpx?isComponent&outputPath=components%2Findex2e7ba292%2Findex")),'login12306-drawer':getComponent(require("../../components/login12306-drawer/index.mpx?isComponent&outputPath=components%2Findexf9ffda7a%2Findex")),'Slogan':getComponent(require("../../components/slogan/index.mpx?isComponent&outputPath=components%2Findexee4c3584%2Findex")),'es-over-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex")),'coupon-banner-simplify':getComponent(require("../../components/coupon/coupon-banner-simplify/index.mpx?isComponent&outputPath=components%2Findex30f50040%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
